import React from 'react';
import {connectRefinementList} from 'react-instantsearch-dom';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
  conatinerList: {
    width: "100%"
  },
  contentList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  itemLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 30,
  },
});

function AlgoliaBrands({items, refine}) {
  const classes = useStyles();

  return (
    <Box className={classes.conatinerList} mb={2}>
      <Box mb={1}>
        <Divider />
      </Box>
      <Typography variant={'h5'}>Marcas</Typography>
      <Box my={1}>
        <Divider />
      </Box>
      <ul className={classes.contentList}>
        {_.sortBy(items, 'label').map((item) => (
          <li key={item.label}>
            <div
              className={classes.itemLabel}
              style={{cursor: 'pointer'}}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
            >
              <div>
                <Box clone mr={2}>
                  <input type={'checkbox'} checked={item.isRefined} />
                </Box>
                <Typography
                  display={'inline'}
                  variant={'body1'}
                  style={{fontWeight: item.isRefined ? 'bold' : ''}}
                >
                  {item.label}
                </Typography>
              </div>
              <Typography variant={'body1'}>{item.count}</Typography>
            </div>
          </li>
        ))}
      </ul>
    </Box>
  );
}

export default connectRefinementList(AlgoliaBrands);
